import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import notFound from '~/images/illustrations/neo-404.svg';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: 5, margin: 5 }}>
      <Helmet title={t('pages.not_found.title')} />
      <Typography variant="h1">{t('pages.not_found.title')}</Typography>
      <Box alt="" component="img" src={notFound} sx={{ maxHeight: '30em' }} />
    </Box>
  );
};
